// import './activations.scss';

export class Activations {}
